module.exports = __webpack_public_path__ + "static/media/v.d83c18e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v.mp4
// module id = Rkoo
// module chunks = 5